<div class="row">
  <div class="col-1-of-4 side-nav">
    <mat-accordion class="no-shadow">
      @for (irbCategoryItem of irbCategories(); track irbCategoryItem) {
        <span>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title
                ><h4 class="catagory-title">
                {{ irbCategoryItem?.display_name }}
              </h4></mat-panel-title
              >
            </mat-expansion-panel-header>
            @for (subCatItem of irbCategoryItem?.sub_categories; track subCatItem) {
              <span>
                <p
                  (click)="selectItem(subCatItem)"
                  [ngClass]="isSelected(subCatItem.id)"
                  >
                  {{ subCatItem?.display_name }}
                </p>
              </span>
            }
          </mat-expansion-panel>
        </span>
      }
    </mat-accordion>
  </div>
  <span class="col-3-of-4 settings-card">
    <ng-content />
  </span>
</div>
